<template>
  <a-modal v-model="visible" width="1000px" :title="$t('confirmReturnBox')">
    <div>
      <span class="batch-set-label">批量设置还箱日期：</span>
      <dol-date
        v-model="batchReturnDate"
        style="width: 300px;"
        :placeholder="$t('pleaseSelectADate')"
        :disabled-date="v => $moment().endOf('day').isBefore(v)"
        @change="batchSetReturnDate"
      />
    </div>

    <a-collapse v-model="openCollapse" class="margin-top-10" expandIconPosition="right">
      <template v-for="order in orderList">
        <a-collapse-panel class="pickup-collapse-panel" :key="order.XB_SHEET_CODE">
          <template #header>
            <div class="pickup-collapse-panel-header">
              {{ $t('orderID') }}：{{ order.XB_SHEET_CODE }} ({{order.INPUT}} / {{order.TOTAL}})
            </div>
          </template>
          <template>
            <dol-list
                :card-flag="false"
                :pagination="false"
                :columns="columns"
                source="local"
                :default-data="order.BOX_LIST"
                bordered
                row-key="BOX_ID"
            >
              <template #RETURN_DATE_TITLE><span class="color-red">*</span> {{ $t('reBoxDate') }}</template>
              <template #RETURN_DATE="field, record">
                <dol-date  :placeholder="$t('pleaseSelectADate')" v-model="record.RETURN_DATE" :disabled-date="v => $moment().endOf('day').isBefore(v)" />
              </template>
              <template #RETURN_MEMO="field, record">
                <a-input v-model="record.RETURN_MEMO" />
              </template>
              <template #RETURN_FILE="field, record">
                <dol-upload :paramsData="uploadParams" :text="$t('uploadReturnBoxDocuments')" serverType="2009" v-model="record.GUID_CODES"/>
              </template>
            </dol-list>
          </template>
        </a-collapse-panel>
      </template>
    </a-collapse>

    <template #footer>
      <div class="confirm-return-modal-footer">
        <div class="error-message">
          {{ errorMessage }}
        </div>
        <div class="button-panel">
          <a-button @click="close">{{ $t('取消') }}</a-button>
          <a-button type="primary" @click="submit">{{ $t('通用_确认提交') }}</a-button>
        </div>
      </div>
    </template>
  </a-modal>
</template>

<script>
export default {
  name: 'confirm-return-modal',
  data () {
    return {
      visible: false,
      boxList: [],
      openCollapse: [],
      loading: false,
      errorMessage: '',
      batchReturnDate: undefined,
    };
  },
  computed: {
    // region 界面展示配置信息
    columns () {
      let columns = [];
      columns.push({ dataIndex: 'BOX_CODE', title: this.$t('通用_箱号') }); // 箱号
      columns.push({ dataIndex: 'RETURN_DATE', slots: { title: 'RETURN_DATE_TITLE' }, scopedSlots: {customRender: 'RETURN_DATE'} }); // 还箱日期
      columns.push({ dataIndex: 'RETURN_MEMO', title: this.$t('租赁_还箱备注'), scopedSlots: {customRender: 'RETURN_MEMO'} }); // 还箱确认说明
      columns.push({ dataIndex: 'RETURN_FILE', width: '400px', title: this.$t('returnBoxDocuments'), scopedSlots: {customRender: 'RETURN_FILE'} }); // 还箱凭证
      return columns;
    },
    uploadParams(){
      return {
        "SYS_TYPE": "20011003",
        "TARGET_CATE": "20021011",
        "TARGET_TYPE": "20071003",
        "TARGET_ID": "",
        "GUID_CODE":""
      };
    },
    // endregion

    // 显示数据
    orderList(){
      const orderList = [], orderMap = {};
      this.boxList.forEach(box => {
        if(!orderMap[box.XB_SHEET_CODE]){
          orderMap[box.XB_SHEET_CODE] = {
            XB_SHEET_CODE: box.XB_SHEET_CODE,
            TOTAL: 0,
            INPUT: 0,
            BOX_LIST: [],
          }
          orderList.push(orderMap[box.XB_SHEET_CODE])
        }
        orderMap[box.XB_SHEET_CODE].BOX_LIST.push(box);
        orderMap[box.XB_SHEET_CODE].TOTAL++;
        if(box.RETURN_DATE){
          orderMap[box.XB_SHEET_CODE].INPUT++;
        }
      });
      return orderList;
    },
  },
  methods: {
    open(boxList){
      this.boxList = boxList;
      this.openCollapse = this.orderList.map(item => item.XB_SHEET_CODE);
      this.visible = true;
    },
    close(){
      this.visible = false;
    },
    batchSetReturnDate(){
      this.boxList.forEach(box => box.RETURN_DATE = this.batchReturnDate);
    },
    submit(){
      // 校验
      this.errorMessage = '';
      const errorBoxList = this.boxList.filter(box => !box.RETURN_DATE);
      if(errorBoxList.length > 0){
        const errorOrderList = [], errorOrderMap = {};
        errorBoxList.forEach(box => {
          if(!errorOrderMap[box.XB_SHEET_CODE]){
            errorOrderList.push(box.XB_SHEET_CODE);
          }
        });
        this.openCollapse = errorOrderList;
        this.errorMessage = this.$t('租赁_下列订单中有箱号未填写还箱日期') + errorOrderList.join(', ');
        return false;
      }

      const submitData = [];
      this.boxList.forEach(box => {
        submitData.push({
          MASTER_ID: box.XH_MASTER_ID,
          FLOW_ID: box.XH_FLOW_ID,
          CHECK_DESC: box.RETURN_REMARK || '',
          RET_DATE: box.RETURN_DATE,
          GUID_CODES: box.GUID_CODES ? box.GUID_CODES.map(val => val.GUID_CODE).join(',') : '',
        });
      });
      this.loading = true;
      this.$h5Api({
        type: '4040',
        data: submitData,
      }).then(({data}) => {
        this.visible = false;
        this.$message.info(this.$t('operateSuccessfully'))
        this.$emit('refresh');
      }).finally(() =>{
        this.loading = false;
      })
    }
  },
};
</script>

<style lang="scss">
@import "../../../assets/scss/constant";
.batch-set-label{
  font-size: 16px;
  font-weight: 700;
  color: $primaryColor;
}
.confirm-return-modal-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .error-message{
    color: red;
  }
}
</style>